import { Typography } from '@mui/material'

const TrackingKeywordAiOverview = ({ data }) => {

  if (!data) {
    return
  }

  let rankAiOverview = -1;
  if (data.history && data.history.length > 0) {
    rankAiOverview = data.history[0].rankAiOverview
  }

  return (
    <Typography>{rankAiOverview > 0 ?rankAiOverview:''}</Typography>
  )
}

export default TrackingKeywordAiOverview;